import script from "./IDESideBarContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDESideBarContent.vue?vue&type=script&lang=ts&setup=true"

import "./IDESideBarContent.vue?vue&type=style&index=0&id=e64a6fa4&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e64a6fa4"]])

export default __exports__